export const phone = /^((\+7|\+8|7|8)*(9)+([0-9]){9})$/;
export const name = /^[a-zа-яё]+$/i;
